<template>
    <div class="cart_ticket">
        <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 80%;display: flex;justify-content: center;align-items: center;">
          <van-loading size="35" color="#de5d0a" />
        </div>
        <div class="container_cart">
            <div v-for="getData in info" :key="getData.id">
                <div class="cart_list" @click="goToViewTicketDetail(getData.id)">
                    <div class="ticket_code">
                        <div class="tickt" :class="{langKh: addFontKhmer}">{{$t('message.ticketCode')}}</div>
                        <div class="coded">{{getData.code}}</div>
                    </div>
                    <div class="ticket_date">
                        <div class="tickt_de" :class="{langKh: addFontKhmer}">{{$t('message.departureDates')}}</div>
                        <div class="tickt_deted">{{getData.travelDate}} {{getData.departure}}</div>
                    </div>
                    <div class="ticket_des">
                        <div class="tickt_des_from">{{getData.destinationFrom}}</div>
                        <div class="tickt_des_img"><img :src="require('@/assets/border-de.svg')" alt="" style="background-size: cover;" /></div>
                        <div class="tickt_deted_to">{{getData.destinationTo}}</div>
                    </div>
                    <div class="view_details">
                        <div class="null"></div>
                        <div class="view_detail" :class="{langKh: addFontKhmer}">{{$t('message.viewDetails')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="noResult" class="noData">
        <p :class="{langKh: addFontKhmer}">{{$t('message.noTripFound')}}</p>
    </div>
    <div v-if="showTicketErrorIn">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedTicketError" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div class="custom-tab-bars">
        <div class="home_pages" @click="goToHome()">
          <font-awesome-icon icon="fa-solid fa-house" />
          <p :class="{langKh: addFontKhmer}" style="font-size: 13px;">{{$t('message.home')}}</p>
        </div>
        <div class="my_booking_pages">
          <font-awesome-icon icon="fa-solid fa-store" style="color: #de5d0a;" />
          <p :class="{langKh: addFontKhmer}" style="font-size: 13px;color: #de5d0a;">{{$t('message.myBooking')}}</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {Loading} from "vant";
export default {
    components: {
        [Loading.name]: Loading
    },
    data() {
        return {
            url: localStorage.getItem("url"),
            bearer: localStorage.getItem("bearer"),
            noResult: false,
            addFontKhmer: false,
            onLine: navigator.onLine,
            loading: true,
            info:[],
            showTicketErrorIn: false,
        }
    },
    methods: {
        closedTicketError() {
            this.showTicketErrorIn = false;
            this.getDataBooking();
        },

        goToHome() {
            localStorage.setItem("homepage", "1");
            this.$router.push("/Home");
        },

        goToViewTicketDetail(id) {
            localStorage.setItem('idbooking', id);
            localStorage.setItem('reloadTicket', 0);
            this.$router.push("/ticket-booking");
        },

        async getDataBooking() {
            this.loading = true;
            const data = {
                'page': 1,
                'rowsPerPage': 200,
                'userTelephone': localStorage.getItem('userphone'),
            }
            const url = this.url +`booking/list`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type": "application/json",
                    "accept": "*/*",
                },
                data: JSON.stringify(data),
                url,
            };
            axios(config).then((response) => {
                this.loading = false;
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.info = response.data.body.data;
                        if(response.data.body.data == 0){
                            this.noResult = true;
                        }else{
                            this.noResult = false;
                        }
                    }
                    }
            }).catch((error) => {
                this.showTicketErrorIn = true;
                console.log(error);
            });
        }

    },
    created() {
        this.$bridge.callHandler("setBarTitle", { title: "My Booking", bgColor: "#de5d0a",color: "#ffffff" });

        if(this.$i18n.locale == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }
        
        if(!this.onLine) {
            this.showTicketErrorIn = true;
        }else{
            this.getDataBooking();
        }
    },
    mounted() {
        window.onpopstate = () => {
            this.goToHome();
        };
    },
    beforeUnmount() {
        window.onpopstate = null;
    },
}
</script>

<style>
    .cart_ticket {
        width: 100%;
    }
    .container_cart {
        padding-bottom: 55px;
    }
    .cart_ticket .cart_list{
        margin: 10px;
        padding: 10px;
        border-radius: 8px;
        box-shadow: rgb(60 64 67 / 30%) 0px 1px 2px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px;
    }
    .cart_ticket .cart_list .ticket_code{
        display: flex;
    }
    .cart_ticket .cart_list .ticket_code .tickt{
        font-weight: 500;
        width: 50%;
    }
    .cart_ticket .cart_list .ticket_code .coded{
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .cart_ticket .ticket_date{
        margin-top: 10px;
        display: flex;
    }
    .cart_ticket .ticket_date .tickt_de{ 
        font-weight: 500;
        font-weight: 500;
        width: 50%;
    }
    .cart_ticket .ticket_date .tickt_deted{
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .cart_ticket .ticket_des{
        margin-top: 10px;
        display: flex;
    }
    .cart_ticket .ticket_des .tickt_des_from {
        font-weight: 500;
        width: 33.33%;
    }
    .cart_ticket .ticket_des .tickt_des_img{
        width: 33.33%;
    }
     .cart_ticket .ticket_des .tickt_deted_to{
        font-weight: 500;
        width: 33.33%;
        text-align: end;
    }
    .cart_ticket .payment_type{
        margin-top: 5px;
        display: flex;
    }
    .cart_ticket .payment_type .pay_type{
        font-weight: 500;
        width: 50%;
    }
    .cart_ticket .payment_type .pay_aba{
        font-weight: 500;
        width: 50%;
        text-align: end;
        color: #de5d0a;
    }
    .cart_ticket .view_details{
        margin-top: 20px;
        display: flex;
    }
    .cart_ticket .view_details .null{
        font-weight: 500;
        width: 50%;
    }
    .cart_ticket .view_details .view_detail{
        width: 50%;
        font-weight: 500;
        text-align: end;
        color: #de5d0a;
    }
    .noData {
        color: #8e8e9d;
        position: absolute;
        top: 50%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .custom-tab-bars {
        background: #fff;
        display: flex;
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 100%;
        position: fixed;
        bottom: 0;
        box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
    }
    .custom-tab-bars .home_pages {
        width: 50%;
        text-align: center;
        color: #646566;
    }
    .custom-tab-bars .my_booking_pages {
        width: 50%;
        text-align: center;
        color: #646566;
    }
</style>